import { useCallback, useMemo, useState } from 'react'

import { TMetricQueryParams } from 'types/GlobalMetric'
import { PeriodFilter } from 'types/GlobalWidget'

/**
 * State-based version of useMetricQueryParams.
 * Manages TMetricQueryParams in React state instead of URL query params.
 * Injects the default period_filter into the returned params but strips it
 * before storing, mirroring the behaviour of the URL-based hook.
 */
export function useMetricQueryParamsState(): [
  TMetricQueryParams,
  (params: TMetricQueryParams) => void
  ] {
  const [queryParams, setQueryParams] = useState<TMetricQueryParams>({})

  const effectiveQueryParams = useMemo<TMetricQueryParams>(
    () => ({
      ...queryParams,
      period_filter:
        queryParams.period_filter ?? PeriodFilter.LAST_12_MONTHS_TO_TODAY
    }),
    [queryParams]
  )

  const setEffectiveQueryParams = useCallback((params: TMetricQueryParams) => {
    setQueryParams(
      params.period_filter === PeriodFilter.LAST_12_MONTHS_TO_TODAY
        ? { ...params, period_filter: undefined }
        : params
    )
  }, [])

  return [effectiveQueryParams, setEffectiveQueryParams]
}
